const apiEndpoint = (): string => {
  const endpoint = '/api/v1/refinance/index'
  const hostName = window.location.hostname
  if (hostName.includes('localhost')) {
    return `https://refinance-index.dpr1.pexainsights.com.au${endpoint}` // TODO placeholder to not require local api
  }
  return endpoint
}

export default apiEndpoint
